import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Shield, Info } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-white/20 dark:border-white/10 mt-20 mb-20 md:mb-0">
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
          {/* Left Section - Branding */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="relative w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-500 via-purple-600 to-pink-500 flex items-center justify-center shadow-2xl hover-glow group cursor-pointer overflow-hidden">
                {/* Animated background */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-purple-500 to-pink-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Shimmer effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                
                <span className="relative text-white font-heading font-bold text-sm tracking-tighter z-10 group-hover:scale-110 transition-transform duration-300">
                  H2G
                </span>
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold gradient-text">
                  Habit2Goals
                </h3>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Build Better Habits, Achieve Your Goals
                </p>
              </div>
            </div>
            <p className="text-sm text-slate-600 dark:text-slate-400 max-w-md">
              A modern habit tracking application designed to help you build consistency and reach your personal development goals.
            </p>
          </div>

          {/* Right Section - Disclaimer */}
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-4 gradient-card rounded-xl border border-yellow-500/20 bg-yellow-500/5">
              <Shield className="w-5 h-5 text-yellow-600 dark:text-yellow-500 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-slate-800 dark:text-slate-100 mb-1 flex items-center gap-2">
                  Medical Disclaimer
                </h4>
                <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
                  This application is designed for habit management and personal productivity purposes only. 
                  It is not intended to provide medical advice, diagnosis, or treatment. Always seek the advice 
                  of a qualified healthcare provider with any questions regarding medical conditions.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-200 dark:border-slate-700 my-6"></div>

        {/* Bottom Section - Copyright */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
            <span>© {currentYear}</span>
            <span className="font-semibold text-slate-700 dark:text-slate-300">
              Tiara Consultants - AI Product Dev Division
            </span>
          </div>

          <div className="flex items-center gap-6 text-xs text-slate-500 dark:text-slate-400">
            <Link 
              to="/privacy" 
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center gap-1"
              data-testid="privacy-policy-link"
            >
              <Info className="w-3 h-3" />
              <span>Privacy Policy</span>
            </Link>
            <Link 
              to="/terms" 
              className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center gap-1"
              data-testid="terms-of-service-link"
            >
              <Shield className="w-3 h-3" />
              <span>Terms of Service</span>
            </Link>
            <span className="flex items-center gap-1">
              <span>Made with</span>
              <Heart className="w-3 h-3 text-red-500 fill-current" />
              <span>by Tiara Consultants</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
